import { useEffect } from 'react';
import { ConvertGoalType } from '../convert/ConvertGoalType';
import { useConvertTrack } from '../convert/useConvertTrack';
import { hasTrackingBeenEnabled } from './trackingUtils';
import { useTracker } from './useTracker';
let hasExposureBeenTrackedACQ111Cache = false;
export function getHasSignupInitiatedBeenTracked() {
  return hasExposureBeenTrackedACQ111Cache;
}
export function setHasSignupInitiatedBeenTracked(value) {
  hasExposureBeenTrackedACQ111Cache = value;
}
export const useTrackSignupInitiated = (shouldTrackSignupInitiated = true) => {
  const trackingEnabled = hasTrackingBeenEnabled();
  const Track = useTracker();
  useConvertTrack(ConvertGoalType.SignupInitiated);
  const hasSignupInitiatedBeenTracked = getHasSignupInitiatedBeenTracked();
  useEffect(() => {
    if (trackingEnabled && !hasSignupInitiatedBeenTracked && shouldTrackSignupInitiated) {
      Track.signupInitiated();
      setHasSignupInitiatedBeenTracked(true);
    }
  }, [Track, hasSignupInitiatedBeenTracked, trackingEnabled, shouldTrackSignupInitiated]);
};